// Thin fetch wrappers over the server's lobby HTTP endpoints. Shapes are
// the shared-protocol types (packages/shared/src/protocol.ts); the desktop
// lobby (packages/client/src/lobby.ts) uses the identical calls.

import type {
  CreateRoomRequest,
  CreateRoomResponse,
  GameTypeCode,
  LobbyResponse,
} from '@bolo2k/shared';

export async function fetchLobby(): Promise<LobbyResponse> {
  const resp = await fetch('/api/lobby');
  if (!resp.ok) throw new Error(`lobby fetch ${resp.status}`);
  return (await resp.json()) as LobbyResponse;
}

export async function createRoom(
  mapName: string,
  gameType: GameTypeCode,
  hiddenMines: boolean,
): Promise<CreateRoomResponse> {
  const body: CreateRoomRequest = { mapName, gameType, hiddenMines };
  const resp = await fetch('/api/rooms', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!resp.ok) throw new Error(`create-room ${resp.status}`);
  return (await resp.json()) as CreateRoomResponse;
}
